import { useEffect } from "react";

const preventRefreshDialog = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  e.returnValue = "";
};

export const usePreventRefresh = (): void => {
  useEffect(() => {
    window.addEventListener("beforeunload", preventRefreshDialog);

    return () => {
      window.removeEventListener("beforeunload", preventRefreshDialog);
    };
  }, []);
};
